import React from "react";
import ReportsHeader from "../../../components/HecoReports/ReportHeader/ReportHeader";
import MindMap from "../../../components/HecoReports/EvidenceMap/EvidenceMap";

import "./evidencemap.css";
import { Navigate } from "react-router-dom";

function EvidenceMap() {
  const timestamp = localStorage.getItem("timestamp");
  return (
    <>
    {/* Generate report if there is a timestamp, otherwise redirects to input form */}
      {timestamp ? (
        <div className="evidence-map-body">
          <ReportsHeader defaultType={"Evidence Map"} />
          <MindMap />
        </div>
      ) : (
        <Navigate to="/inputform" />
      )}
    </>
  );
}

export default EvidenceMap;
